
import { Component, Vue, Prop } from 'vue-property-decorator'
import DOMPurify from 'dompurify'

/**
 * HTMLコンテンツの表示
 */
@Component
export default class HtmlContent extends Vue {
  /** 表示するhtml */
  @Prop()
  content!: string

  /**
   * htmlをサニタイズして返す
   *
   * @returns サニタイズ済みHTML
   */
  private get sanitizedContent(): string {
    return DOMPurify.sanitize(this.content, { ADD_ATTR: ['target'] })
  }
}
